import { EditModerationBookProperties } from '~/api/admin/adminBookTypes';
import { provider } from '~/api/provider/provider.config';
import { handleRejectedRequest } from '~/api/provider/providerErrors';
import { ApiResponse, RejectedRequest } from '~/api/provider/providerTypes';

const namespace = Symbol('namespace');

export const adminBookAPI = {
  [namespace]: '/admin/books',
  async updateBookProperties({ slug, ...data }: EditModerationBookProperties) {
    try {
      const response = await provider.post<
      ApiResponse<void, RejectedRequest<void>>
      >(`${this[namespace]}/book/${slug}/properties`, data);

      return response.data;
    } catch (error) {
      return await handleRejectedRequest<void>(error);
    }
  },
};
